import { useContext } from "react";

import { AmplifyContext } from "./AmplifyManager";

export const useAmplify = () => useContext(AmplifyContext);
